module.exports = __webpack_public_path__ + "img/void.27bf9e3d.svg";